import lrz from 'lrz';
import moment from 'moment';

// 获取cookie
const getCookie = function (name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  return (arr && arr[2]) || null;
};


export default {
  // 获取cookie
  getCookie,
  // 删除cookie
  deleteCookie: function (name) {
    const exp = new Date();
    exp.setTime(exp.getTime() - 1);
    const cval = getCookie(name);
    if (cval != null) {
      document.cookie = `${name}=${cval};expires=${exp.toGMTString()}`;
    }
  },
  // 生成带时间随机数
  randomDateNum: function (len) {
    len = len || 5;
    return `${moment().format('YYYYMMDDHHmm')}${Number.parseInt(Math.random() * 10 * len, 10)}`;
  },
  // 生成普通随机数
  randomNum: function (len) {
    len = len || 5;
    return Number.parseInt(Math.random() * 10 * len, 10);
  },
  // 图片压缩
  imageZipped: function (file, cb) {
    lrz(file, { width: 800, height: 800, quality: 0.7 }).then(
      (rst) => {
        cb(rst);
      }).catch((err) => {
      console.error(err);
      cb(undefined);
    }).always(() => {
      // 不管是成功失败，都会执行
    });
  },
  // 获取最近日期(默认30天)
  getLatestDate: function (dayCount) {
    dayCount = dayCount || 30;
    const date = new Date();
    const data = [];
    for (let i = 0; i < dayCount; i++) { // 获取往后dayCount天的数据
      const years = date.getFullYear(); // 获取当前年份
      const month = date.getMonth() + 1; // 获取当前月份（0-11）
      const day = date.getDate(); // 获取当前日（1-31）
      const week = date.getDay(); // 获取当前星期X(0-6,0代表星期天)
      const dateObj = {
        years: years,
        month: month < 10 ? `0${month}` : month,
        day: day,
        date: `${years}-${month}-${day}`,
        week: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][week],
      };
      data.push(dateObj);
      date.setDate(date.getDate() + 1);
    }
    return data;
  },
  // 输入法软盘是否展开
  // 该方法仅适用安卓,ios弹出输入法出现问题滚动轴不在顶部可以尝试document.body.scrollTop=0 来解决
  onKeyboard: function (open, close) {
    open = open || function () {
    };
    close = close || function () {
    };
    const defaultWindowHeight = window.innerHeight; // 获取初始默认窗口高度
    window.onresize = () => {
      const currentWindowHeight = window.innerHeight; // 当前窗口高度
      if (currentWindowHeight < (defaultWindowHeight - 20)) {
        open();
        return;
      }
      close();
    };
  },
};



// WEBPACK FOOTER //
// ./src/config/utils.js